import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

const faqGroups = [
  {
    title: "Orders & payment",
    items: [
      ["How do I know my order was received?", "After checkout, an order confirmation is sent to the email address you entered. If it does not arrive, check your spam folder or contact us."],
      ["Can I change an order?", "Contact us as soon as possible. We cannot promise changes after packing or dispatch has started."],
      ["When is payment taken?", "The timing depends on the payment method shown at checkout. Any total, tax and delivery charge is displayed before you confirm."],
    ],
  },
  {
    title: "Delivery & returns",
    items: [
      ["When will my parcel leave?", `In-stock orders usually leave within ${siteConfig.shipping.dispatchWindow}. Carrier estimates begin after dispatch.`],
      ["Can I track my order?", "Where tracking is available, its link is included in the dispatch message."],
      ["How long do I have to return an item?", `Eligible items may be returned within ${siteConfig.shipping.returnsWindow} days, subject to the conditions on our returns page.`],
    ],
  },
  {
    title: "Products & care",
    items: [
      ["How do I choose a size?", "Use the sizes listed on each product page. If you are between sizes or need garment-specific guidance, email our team before ordering."],
      ["Why can colours vary?", "Screens, lighting and the character of natural fibres can produce small differences. Product descriptions identify the intended colour."],
      ["Where can I find care guidance?", "The product page includes a care note. Always follow the sewn-in care label supplied with the garment."],
    ],
  },
];

function Faqs() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="info-page" id="main-content">
      <div className="info-shell info-shell--narrow">
        <nav className="info-breadcrumb" aria-label="Breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">FAQs</span>
        </nav>
        <header className="info-page__header info-page__hero">
          <p className="info-page__eyebrow">Customer help</p>
          <h1>Frequently asked questions.</h1>
          <p className="info-page__lead">Quick answers about ordering, delivery, returns and caring for your pieces.</p>
        </header>

        {faqGroups.map((group) => (
          <section className="info-faq" key={group.title} aria-labelledby={`faq-${group.title.replace(/\W+/g, "-").toLowerCase()}`}>
            <div>
              <p className="info-page__eyebrow">Help</p>
              <h2 id={`faq-${group.title.replace(/\W+/g, "-").toLowerCase()}`}>{group.title}</h2>
            </div>
            <div className="info-faq__list">
              {group.items.map(([question, answer]) => (
                <details key={question}>
                  <summary>{question}</summary>
                  <p>{answer}</p>
                </details>
              ))}
            </div>
          </section>
        ))}

        <aside className="info-page__contact-card">
          <p className="info-page__eyebrow">Need another answer?</p>
          <h2>We are here to help.</h2>
          <p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> or use our <Link to="/contact" onClick={toTop}>contact form</Link>.</p>
        </aside>
      </div>
    </main>
  );
}

export default Faqs;
